module.exports = __webpack_public_path__ + "static/img/vip5.2b576e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/member/vip5.png
// module id = hHx4
// module chunks = 1